import { forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Text, TextProps } from '@backstage/ui';

const styles = createStyles({
  root: {},
});

export interface ExpressionPropertyProps
  extends TextProps,
    WithStyles<typeof styles> {}

const ExpressionProperty = forwardRef<HTMLDivElement, ExpressionPropertyProps>(
  (props, ref) => {
    const { classes, className, ...rest } = props;
    return (
      <Text
        ref={ref}
        className={classNames(className, classes.root)}
        {...rest}
      />
    );
  },
);

ExpressionProperty.displayName = 'Expression.Property';

export default withStyles(styles)(ExpressionProperty);
